import React from "react";
import "./about.css";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";

const year = new Date().getFullYear(); 
const experience = year - 2022;


const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__content">
          <p className="about__intro">
          I am a passionate Senior Software Engineer with {experience}+ years of experience in web application development, specializing in the MERN Stack (MongoDB, Express.js, React.js, Node.js). I hold a Computer Science degree from Eastern University.  I am passionate about solving complex problems, writing maintainable code, and collaborating with teams to deliver high-quality software solutions.
          </p>

          <div className="about__cards">
          <article className="about__card">
  <FaAward className="about__icon" />
  <h5>Experience</h5>
  <small>4+ Years in MERN Stack & Web Development</small>
</article>

<article className="about__card">
  <FiUsers className="about__icon" />
  <h5>Clients / Teams</h5>
  <small>10+ Collaborative Projects with Teams & Clients</small>
</article>

<article className="about__card">
  <VscFolderLibrary className="about__icon" />
  <h5>Projects</h5>
  <small>20+ Real-world Web Applications Delivered</small>
</article>
          </div>

          <p className="about__description">
            I am always exploring new technologies, best practices, and modern
            design trends to keep my work up to date. My goal is to join a
            forward-thinking team where I can contribute, grow, and help build
            meaningful digital products.
          </p>

          <div className="about__cta">
            <a href="#portfolio" className="btn">
              View My Work
            </a>
            <a href="#contact" className="btn btn-primary">
              Let&apos;s Talk
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
